import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Mock4allSingletonService {

  public get mockId(): string {
    return localStorage.getItem("mockId");
  }

  public set mockId(input: string) {
    localStorage.setItem("mockId", input);
  }

}
